const SUMMARY_EVIDENCE_TOKEN = /\s*\[(?:S[A-Za-z0-9]+R\d+N\d+|S\d+)\]/g;

export function stripSummaryEvidence(value: string): string {
  return value
    .replace(SUMMARY_EVIDENCE_TOKEN, "")
    .replace(/[ \t]+([.,!?;:。！？；：])/gu, "$1")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}
